import { render, staticRenderFns } from "./DataCardRow.vue?vue&type=template&id=bde4d2a4"
import script from "./DataCardRow.vue?vue&type=script&lang=js"
export * from "./DataCardRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports